<template>

<app-view-list-field align="center" :demoted-icon="field.type" :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

    <span>{{ value }}</span>
    
</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted'],

	computed: {

		value: function() {

			return (this.item.game.version) ? this.item.game.version.year : this.item.game.published

		}

	}

}

</script>

<style scoped>

</style>